
import * as React from 'react';
import { UIComponentViewImpl } from '../uicomponentview';
import { PaginationComponentProps, PaginationComponentState, PaginationComponentHandler } from './paginationcomponent';
import { PaginationCSSStyle } from './paginationcss';
import { PaginationCardComponent } from './paginationcard/paginationcardcomponent';
import { ButtonComponent } from '../button/buttoncomponent';
import { GroupButtonCSSStyleImpl } from '../../components/home/groups/managegroup/groupbuttoncss';
import { Strings } from '../../../utils/resources/strings';
import { ButtonCSSStyleImpl } from '../button/buttoncss';
import { DisabledButtonCSSStyleImpl } from '../../components/home/doityourself/buttoncss';


export class PaginationViewImpl<T> extends UIComponentViewImpl<T>
{
    bindHandlers()
    {
        this.onPageSelect = this.onPageSelect.bind(this);
        this.leftArrowClick = this.leftArrowClick.bind(this);
        this.rightArrowClick = this.rightArrowClick.bind(this);
    }

    draw(props: PaginationComponentProps<T>, state: PaginationComponentState, cssStyle: PaginationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("------draw()pagination: isLeft: " + state.isLeftArrowEnabled);
        console.log("------draw()pagination: isright: " + state.isRightArrowEnabled);
       return (
        <div style={{display: "flex", flexFlow: "row wrap", justifyContent: "center", textAlign: "center", alignItems: "center"}}>
            {/* {state.isLeftArrowEnabled && <div style={cssStyle.getLeftArrowDivCSSStyle()} onClick={this.leftArrowClick}>
                <img style={cssStyle.getLeftArrowCSSStyle()} src={props.context.getResources().getImage("previous_black.svg")} height="30px"/>
            </div>}
                {
                   this.getListOfPages(state)
                }
            {state.isRightArrowEnabled && <div style={cssStyle.getRightArrowDivCSSStyle()} onClick={this.rightArrowClick}>
                <img style={cssStyle.getRightArrowCSSStyle()} src={props.context.getResources().getImage("next_black.svg")} height="30px"/>
            </div>} */}
        
        {<div style={cssStyle.getLeftArrowDivCSSStyle()}>
                <ButtonComponent onClick={state.isLeftArrowEnabled ? this.leftArrowClick : ()=>{}} style={state.isLeftArrowEnabled ? new GroupButtonCSSStyleImpl(props.context): new DisabledButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.previous)}/>
            </div>}
                {
                   <PaginationCardComponent selectedPageNumber={state.currentPageNo} paginationIndex={state.currentPageNo} onSelectNext={()=>{}} context={this.getUIProps().context} key={state.currentPageNo}/>}
            {<div style={cssStyle.getRightArrowDivCSSStyle()}>
            <ButtonComponent onClick={state.isRightArrowEnabled ? this.rightArrowClick: ()=>{}} style={state.isRightArrowEnabled ? new ButtonCSSStyleImpl(props.context) : new DisabledButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.next)}/>
            </div>}
        </div>
       );
    }

    // getListOfPages(state: PaginationComponentState)
    // {
    //     let list = [];

    //     for(let i= state.startPageNo; i <= state.endPageNo; i++ )
    //     {
    //         // list.push(<div key={i} style={{paddingLeft: "10px", paddingRight: "10px"}} onClick={()=>this.onPageSelect(i)}>{i}</div>);
    //         list.push(<PaginationCardComponent selectedPageNumber={state.currentPageNo} paginationIndex={i} onSelectNext={this.onPageSelect} context={this.getUIProps().context} key={i}/>);
    //     }

    //     return list;
    // }

    private leftArrowClick()
    {
        (this.getUIComponentHandler() as PaginationComponentHandler).onLeftArrowSelect();
    }

    private rightArrowClick()
    {
        (this.getUIComponentHandler() as PaginationComponentHandler).onRightArrowSelect();
    }

    private onPageSelect(pageNumber: number)
    {
        (this.getUIComponentHandler() as PaginationComponentHandler).onPageSelect(pageNumber);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationview.tsx